class GatewayLevelLogsDatatable {
    constructor(){
        let organizationID = new URLSearchParams(window.location.search).get('organizationID')
        this.datatable = this.init('#gateway-level-logs-datatable', organizationID);
        this.datatableActions(organizationID);
        this.filterActions();
    }
    init(el, organizationID){
        const datatable =  $(el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            order: [[4, 'asc']],
            searchCols: [
                null,
                null,
                null,
                null,
                { "search": (moment().startOf('isoWeek').format("YYYY-MM-DD hh:mm:ss")+' - '+moment().endOf('isoWeek').format("YYYY-MM-DD hh:mm:ss")), "regex": false }
            ],
            ajax: {
                url: '?do=getGatewayLevelAccessLogs',
                type: 'POST',
                data: {
                    organizationID: organizationID,
                }
            },
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=gateway-level-logs-datatable_length]').select2({minimumResultsForSearch: -1});
            },
            columns: [
                {
                    data: 'uuid',
                    title: 'Member',
                    className: 'min-w-100px',
                    sortable: false,
                    render: function (data, type, row) {
                        return new MemberInfoGenerator(row).generateTableMember();
                    }
                },
                {
                    data: 'gatewayIP',
                    title: 'Gateway',
                    className: 'min-w-150px',
                    sortable: false,
                    render: function (data, type, row) {
                        return '<div class="d-flex align-items-center">' +
                            '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                            '           <div class="symbol-label bg-light-primary border border-2 border-white overflow-hidden">' +
                            '               <img src="/media/goodaccess/country-flags/png100px/' + row['gatewayIso2'] + '.png" class="h-40px mw-unset" alt="flag">' +
                            '           </div>' +
                            (row['gatewayStatus'] === 'down' ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-7 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'text-center\'>Gateway status: <b>DOWN<b></div>">!</span>' : '')+
                            '       </div>' +
                            '       <div class="d-flex justify-content-start flex-column">' +
                            '           <div '+ (row['editGateway'] && row['gatewayID'] ? 'id="'+row['gatewayID']+'"' : '' )+'><div class="fw-bold text-primary mb-1 fs-6' + (row['editGateway'] && row['gatewayID'] ? ' text-decoration-underline-ga primary edit-gateway' : '') + '">' + row['gatewayName'] + '</div> '+(!row['gatewayID'] ? '<i class="fa-regular fa-circle-question" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Deleted Gateway"></i>' : '')+'</div>'+
                            '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">' + row['gatewayIP'] + '</span>' +
                            '       </div>' +
                            '   </div>';
                    }
                },
                {
                    data: 'from_ip',
                    title: 'From IP',
                    sortable: false,
                    render: function (data, type, row) {
                        return '<div class="text-nowrap">'+row['from_ip']+'<i class="fa-regular fa-circle-question ms-1 fs-7 get-ip-info cursor-help" data-value="'+row['from_ip']+'"></i></div>';
                    }
                },
                {
                    data: 'log_protocol',
                    title: 'Protocol',
                    sortable: false,
                    render: function (data, type, row) {
                        return row['log_protocol'];
                    }
                },
                {
                    data: 'start',
                    title: 'Start',
                    className: 'min-w-90px',
                    sortable: true,
                    render: function (data, type, row) {
                        return `<span data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-content="${row['timezone']}">${row['start']}</span>`;
                    }
                },
                {
                    data: 'stop',
                    title: 'Stop',
                    className: 'min-w-90px',
                    sortable: true,
                    render: function (data, type, row) {
                        if(row['stop'] === 'Connected'){
                            return '<span class="badge badge-light-success">Connected</span>';
                        }
                        return `<span data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-content="${row['timezone']}">${row['stop']}</span>`;
                    }
                },
                {
                    data: 'duration',
                    title: 'Duration',
                    sortable: true,
                    render: function (data, type, row) {
                        return row['duration'];
                    }
                },
                {
                    data: 'uploadedData',
                    title: 'Data',
                    sortable: true,
                    className: 'min-w-80px',
                    render: function (data, type, row) {
                        return '<div class="text-nowrap">' +
                            '       <i class="fa-solid fa-arrow-up"></i>' +
                            '       <span>'+row['uploadedData']+'</span>' +
                            '   </div>' +
                            '   <div class="text-nowrap">' +
                            '       <i class="fa-solid fa-arrow-down"></i>' +
                            '       <span>'+row['downloadedData']+'</span>' +
                            '   </div>';
                    }
                },
            ]
        }).on('preDraw', function () {
            $('#gateway-level-logs-datatable_wrapper').show();
            $('#gateway-level-logs-datatable_no-results').addClass('d-none').removeClass('d-flex flex-center flex-column');
        }).on('draw', function () {
            if(datatable.page.info().recordsTotal === 0){
                $('#gateway-level-logs-datatable_wrapper').hide();
                $('#gateway-level-logs-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            } else {
                $('#gateway-level-logs-datatable_wrapper').show();
                $('#gateway-level-logs-datatable_no-results').addClass('d-none').removeClass('d-flex flex-center flex-column');
            }
        });
        // Init and add delay to datatable search
        new DatatableSearchDelay(datatable, '[data-kt-docs-table-filter=search]');
        return datatable;
    }
    datatableActions(organizationID){
        $(document).on('mouseover','#gateway-level-logs-datatable .get-ip-info',function(){
            const clickedEl = $(this);
            if(!clickedEl.attr('data-bs-toggle')){
                const ip = clickedEl.attr('data-value');
                if(ip){
                    $.ajax({
                        url:  '/gateway-access-logs/?do=getIpInfo',
                        type: 'POST',
                        dataType: '',
                        data: { ip: ip, organizationID: organizationID}
                    }).done(function(data) {
                        clickedEl.attr('data-bs-toggle','popover');
                        clickedEl.attr('data-bs-placement','top');
                        clickedEl.attr('data-bs-trigger','hover');
                        clickedEl.attr('data-bs-html','true');
                        clickedEl.attr('data-bs-content',`<div class='d-flex align-items-center'><div class='symbol symbol-30px me-3 border ga-border-primary-300 symbol-circle'><div class='symbol-label bg-light-primary border border-2 border-white overflow-hidden'>`+(data[`iso2`] ? `<img src='/media/goodaccess/country-flags/png100px/` + data[`iso2`].toLowerCase() + `.png' class='h-30px' alt='flag'>` : `<i class='fa-solid fa-question fs-1'></i>`)+`</div></div><div class='d-flex justify-content-start flex-column'>`+(data[`country`] ? `<div><span class='fw-bold text-white mb-1 fs-7'>`+data[`country`]+`</span></div>` : ``)+`<span class='fw-semibold d-block fs-8 text-white'>` + data['city'] + `</span></div></div>`);
                        clickedEl.popover('show');
                    });
                }
            }
        });
    }
    filterActions(){
        this.initSelect2();
        this.initDateTimePicker();
        this.resetFilters();

        const thisClass = this;
        const filterButton = document.querySelector('[data-kt-docs-table-filter="filter"]');
        if(filterButton){
            filterButton.addEventListener('click', function () {
                thisClass.applyFilter();
            });
        }
    }
    initSelect2(){
        // Format Member options
        const tagFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            span.innerHTML = item.text;
            return $(span);
        }
        // Format Member results
        const optionFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            let template = '';
            template += '<div class="d-flex align-items-center">';
            template += item.element.getAttribute('data-kt-rich-content-avatar');
            template += '<div class="d-flex flex-column">'
            template += '<span class="fs-6 fw-bold lh-1 text-primary">' + item.text + item.element.getAttribute('data-kt-rich-content-badges') + '</span>';
            template += '<span class="fw-semibold ga-text-primary-800 fs-8">' + item.element.getAttribute('data-kt-rich-content-subcontent') + '</span>';
            template += '</div>';
            template += '</div>';
            span.innerHTML = template;
            return $(span);
        }

        // Init Select2
        $('[data-kt-docs-table-filter=members]').select2({
            placeholder: "Select an option",
            templateSelection: tagFormat,
            templateResult: optionFormat,
        });
        $('[data-kt-docs-table-filter=gateways]').select2({
            laceholder: "Select an option",
            templateSelection: tagFormat,
            templateResult: optionFormat,
        });
    }
    initDateTimePicker(){
        const dateEl = $("[data-kt-docs-table-filter=date]");

        let start = moment().startOf('isoWeek');
        let end = moment().endOf('isoWeek');

        function formatDate(start, end) {
            dateEl.html(start.format("MMM D, YYYY") + " - " + end.format("MMM D, YYYY"));
        }

        dateEl.daterangepicker({
            startDate: start,
            endDate: end,
            locale: {
                format: "MMM D, YYYY"
            },
            ranges: {
                "Today": [moment(), moment()],
                "Yesterday": [moment().subtract(1, "days"), moment().subtract(1, "days")],
                "This Week": [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
                "Last Week": [moment().startOf('isoWeek').subtract(7, "days"), moment().endOf('isoWeek').subtract(7, "days")],
                "This Month": [moment().startOf("month"), moment().endOf("month")],
                "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")]
            }
        }, formatDate);
        formatDate(start, end);
    }
    resetFilters(){
        const thisClass = this;

        // Select reset button
        const resetButton = document.querySelector('[data-kt-docs-table-filter="reset"]');
        if(resetButton){
            // Reset datatable
            resetButton.addEventListener('click', function () {
                // Reset members and domains
                $('[data-kt-docs-table-filter=members]').val([]).trigger('change');
                $('[data-kt-docs-table-filter=gateways]').val([]).trigger('change');
                // Reset Date filter
                $('[data-kt-docs-table-filter=date]').val('');

                thisClass.applyFilter(true);
            });
        }
    }
    applyFilter(reset = false){
        let numberOfActiveFilters = 1; // Date is always set

        if(reset){
            this.datatable.columns().search('');
        } else {
            // Select filter options
            let date = document.querySelector('[data-kt-docs-table-filter="date"]');

            let members = $('[data-kt-docs-table-filter="members"]').select2('data');
            let membersArr = [];
            for(const i in members){
                if(members[i].id !== ''){
                    membersArr.push(members[i].id);
                }
            }

            let gateways = $('[data-kt-docs-table-filter="gateways"]').select2('data');
            let gatewaysArr = [];
            for(const i in gateways){
                if(gateways[i].id !== '') {
                    gatewaysArr.push(gateways[i].id);
                }
            }

            this.datatable.column(0).search(JSON.stringify(membersArr));
            numberOfActiveFilters += membersArr.length;
            this.datatable.column(1).search(JSON.stringify(gatewaysArr));
            numberOfActiveFilters += gatewaysArr.length;
            this.datatable.column(4).search(date.value);
        }

        this.datatable.draw();

        $('#gatewayLevelLogsNumberOfFilters').text(numberOfActiveFilters);
    }
}
window.GatewayLevelLogsDatatable = GatewayLevelLogsDatatable;